<template>
  <v-navigation-drawer v-model="menuOpen" v-if="menuOpen" class="sidebar"
    fixed
    temporary
    touchless
    width = "400"
    >
    <v-flex class="">
        <v-toolbar flat>

      <v-flex class="pl-2 headline">
        Menu
      </v-flex>
 



        <v-btn icon @click.stop="setMenuOpen(false)">
          <v-icon>chevron_left</v-icon>
        </v-btn>

        </v-toolbar> 
    </v-flex>

    <v-divider></v-divider>

    <v-flex class="">
     
      <v-list class="pl-4 pt-4">

        <v-list-item exact class="pt-2"
          to="/" >
          <v-list-item-action>
          <v-icon>map</v-icon>
          </v-list-item-action>
          <v-list-item-content>
          <v-list-item-title>Map</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        
        <v-list-item exact class="pt-2"
          to="developer" >
          <v-list-item-action>
          <v-icon>code</v-icon>
          </v-list-item-action>
          <v-list-item-content>
          <v-list-item-title>Developer Tools</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item exact class="pt-2"
          to="about" >
          <v-list-item-action>
          <v-icon>info</v-icon>
          </v-list-item-action>
          <v-list-item-content>
          <v-list-item-title>About Room Finder</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-flex>
        </v-layout>
    </v-flex>
    
  </v-navigation-drawer>
</template>

<script>

//import { loadModules } from 'esri-loader'
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";

export default {

  data () {
      return {
      }
  },

  computed: {
    ...mapState({ 
          }),

    menuOpen: {
      get () {
        return this.$store.state.ui.menuOpen
      },
      set (value) {
        this.setMenuOpen(value)
      }
    },
  },

  methods: {
    ...mapMutations(['setMenuOpen' ]),
    ...mapActions(['']),
    
  }
}

</script>

<style>

  .sidebar {
    display: flex !important;
    flex-direction: column !important;
    z-index: 200 !important;
  }

  .switches .v-label {
    left: 10px !important;
  }

  .bigSub {
    font-size: 16pt !important;
  }

  .search .v-input__slot {
    padding-left:23px !important;
  }


</style>
